// slice habdles local state for add product multistep form
// necessary to centralize state management for add product form over the steps

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  product: {
    postTitle: "", // required
    postDetails: "", // required
    postCategory: "apartment", // required, default category
    postType: "rent", // required, default rent
    space: 0, // required
    price: 0, // required
    address: null, // required
    location: {
      // location from map or auto-generated from adderess which is required
      lat: null,
      lng: null,
    },
    // optional fields
    finishingType: null,
    rooms: null,
    bathrooms: null,
    buildingFloors: null,
    FloorNumber: null,
    constructionYear: null,
  },
};

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setProduct: (state, action) => {
      state.product = { ...state.product, ...action.payload };
    },
    clearProduct: (state, action) => {
      state.product = { ...initialState.product };
    },
  },
});

export const { setProduct, clearProduct } = productSlice.actions;

export default productSlice.reducer;
